import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { AlvineBackLayout } from 'src/layouts/simple';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

const MeInvitationsPage = lazy(() => import('src/pages/dashboard/me/invitations'));

export const invitationsRoutes: RouteObject[] = [
  {
    path: 'invitations',
    element: (
      <AuthGuard>
        <AlvineBackLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AlvineBackLayout>
      </AuthGuard>
    ),
    children: [{ element: <MeInvitationsPage />, index: true }],
  },
];
